export const CustomEvents = {
    AudioTrackChange: "audiotrackchange",
    StateChange: "statechange",
    SourceLoaded: "sourceloaded",
};
